import type { User } from '@/contexts/AuthContext';

/**
 * Determina a rota padrão baseada no role do usuário.
 * - Super-administradores vão direto ao painel de tenants.
 * - Demais usuários usam /app/dashboard (SmartDashboard escolhe o conteúdo).
 */
export function getDefaultRoute(user: User | null): string {
  if (user?.isSuperAdmin) {
    return '/admin/tenants';
  }
  return '/app/dashboard';
}
